export enum AsyncJobStatus {
    PENDING = 'pending',
    IN_PROGRESS = 'in-progress',
    SUCCESS = 'success',
    FAILED = 'failed',
}

export enum JobName {
    SYNC_SALESFORCE = 'sync-salesforce',
    SYNC_SALESFORCE_PRODUCTS = 'sync-salesforce-products',
    CUSTOMER_UTILITY_BILLS_IMPORT = 'customer-utility-bills-import',
}

export interface AsyncJobContextSection {
    title: string;
    keys: { key: string; label: string }[];
}

export const AsyncJobContextSections: AsyncJobContextSection[] = [
    {
        title: 'Accounts',
        keys: [
            { key: 'salesforceAccountsAmount', label: 'Salesforce Amount' },
            { key: 'dbAccountsAmount', label: 'DB Amount' },
            { key: 'accountsToCreate', label: 'Created' },
            { key: 'accountsToUpdate', label: 'Updated' },
            { key: 'accountsToDelete', label: 'Deleted' },
        ],
    },
    {
        title: 'Meters',
        keys: [
            { key: 'salesforceMetersAmount', label: 'Salesforce Amount' },
            { key: 'metersWithSyncedFlagAmount', label: 'With Synced Flag' },
            { key: 'dbMetersAmount', label: 'DB Amount' },
            { key: 'metersToCreate', label: 'Created' },
            { key: 'metersToUpdate', label: 'Updated' },
            { key: 'metersToDelete', label: 'Deleted' },
        ],
    },
    {
        title: 'Meter Enrollments',
        keys: [
            { key: 'salesforceMeterEnrollmentsAmount', label: 'Salesforce Amount' },
            { key: 'dbMeterEnrollmentsAmount', label: 'DB Amount' },
            { key: 'meterEnrollmentsToCreate', label: 'Created' },
            { key: 'meterEnrollmentsToUpdate', label: 'Updated' },
            { key: 'meterEnrollmentsToDelete', label: 'Deleted' },
        ],
    },
    {
        title: 'Nominations',
        keys: [
            { key: 'salesforceNominationsAmount', label: 'Salesforce Amount' },
            { key: 'dbNominationsAmount', label: 'DB Amount' },
            { key: 'nominationsToCreate', label: 'Created' },
            { key: 'nominationsToUpdate', label: 'Updated' },
            { key: 'nominationsToDelete', label: 'Deleted' },
            { key: 'nominationsToUpdateInSalesforce', label: 'Update in SF' },
        ],
    },
    {
        title: 'Products',
        keys: [
            { key: 'salesforceProductsAmount', label: 'Salesforce Amount' },
            { key: 'dbProductsAmount', label: 'DB Amount' },
            { key: 'productsToCreate', label: 'Created' },
            { key: 'productsToUpdate', label: 'Updated' },
            { key: 'productsToDelete', label: 'Deleted' },
        ],
    },
    {
        title: 'Opportunities',
        keys: [
            { key: 'salesforceOpportunitiesAmount', label: 'Salesforce Amount' },
            { key: 'dbOpportunitiesAmount', label: 'DB Amount' },
            { key: 'opportunitiesToCreate', label: 'Created' },
            { key: 'opportunitiesToUpdate', label: 'Updated' },
            { key: 'opportunitiesToDelete', label: 'Deleted' },
        ],
    },
    {
        title: 'Customer Utility Bills',
        keys: [
            { key: 'utilityCustomerBillsTotalRecords', label: 'Total Records' },
            { key: 'utilityCustomerBillsCreatedRecords', label: 'Created Records' },
            { key: 'utilityCustomerBillsSkippedRecords', label: 'Skipped Records' },
        ],
    },
    {
        title: 'Customer Utility Bill Source Files',
        keys: [
            { key: 'utilityCustomerBillSourceFilesDownloaded', label: 'Downloaded' },
            { key: 'utilityCustomerBillSourceFilesDownloadFailed', label: 'Download Failed' },
            { key: 'utilityCustomerBillSourceFilesParsed', label: 'Parsed' },
        ],
    },
    {
        title: 'Customer Utility Bill Files',
        keys: [
            { key: 'utilityCustomerBillFilesTotalRecords', label: 'Total Records' },
            { key: 'utilityCustomerBillFilesCreatedRecords', label: 'Created Records' },
            { key: 'utilityCustomerBillFilesSkippedRecords', label: 'Skipped Records' },
            { key: 'utilityCustomerBillFilesDownloaded', label: 'Downloaded' },
            { key: 'utilityCustomerBillFilesDownloadFailed', label: 'Download Failed' },
        ],
    },
    {
        title: 'General',
        keys: [{ key: 'changesSavedToDB', label: 'Changes Saved to DB' }],
    },
];

export interface IAsyncJob {
    request_id: string;
    requested_by: string;
    job_name: JobName;
    status: AsyncJobStatus;
    created_at: string;
    updated_at: string;
    context?: any;
    started_at?: string;
    finished_at?: string;
}

export interface ICreateAsyncJob {
    job_name: JobName;
}
